exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header[data-v-5bf5a86e]{height:45px;line-height:45px;font-size:16px;border-top:1px solid #d9e0e6;border-bottom:1px solid #d9e0e6}.tab-header-text[data-v-5bf5a86e]{border-left:1px solid #d9e0e6;border-right:1px solid #d9e0e6;text-align:center;cursor:pointer;color:#31aaff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5bf5a86e","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/outCome/index.vue
// module id = vCRz
// module chunks = 0